import Image, { type ImageProps } from 'next/image';
import SectionalWritebackRebrand from './sectional-writeback-illustration-rebrand.png';

export const SectionalWritebackIllustration = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'sectional writeback', ...rest } = props;

  return <Image src={SectionalWritebackRebrand} alt={alt} {...rest} />;
};
